// export const BASE_URL="https://gps.axiom.az/api";
// export const PICTURE_URL="https://gps.axiom.az/img/uploads/";

export const BASE_URL="https://aqsinheyderli-001-site1.ctempurl.com/api";
export const PICTURE_URL="https://aqsinheyderli-001-site1.ctempurl.com/img/uploads/";
